import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    position: "relative",
    display: "inline-flex",
  },
}));

const MetaConnectButton = ({
  onClick,
  connecting = false,
  disabled = false,
  fullWidth = false,
  variant = "contained",
  color = "primary",
  label,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Button
        variant={variant}
        color={color}
        fullWidth={fullWidth}
        disabled={disabled || connecting}
        onClick={onClick}
      >
        {label || i18n.t("connections.meta.connectButton")}
      </Button>
      {connecting && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  );
};

export default MetaConnectButton;
